// extracted by mini-css-extract-plugin
module.exports = {"filtersButton":"FilterButton_filtersButton__C1KdJ","active":"FilterButton_active__5Le2Z","remove":"FilterButton_remove__YxBZ3"};